import { render, staticRenderFns } from "./Application-Modernization.vue?vue&type=template&id=8ff87638&scoped=true&"
import script from "./Application-Modernization.vue?vue&type=script&lang=js&"
export * from "./Application-Modernization.vue?vue&type=script&lang=js&"
import style0 from "./Application-Modernization.vue?vue&type=style&index=0&id=8ff87638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff87638",
  null
  
)

export default component.exports